import React from 'react'
import LoadingIcon from './../../../../components/loading_icon/LoadingIcon'

import './SlimLoadingScreen.scss'

const SlimLoadingScreen = ({ mobileApp }) => {
    let mobileAppClass = mobileApp ? 'mobile' : ''
    return (
        <div className={`LoadingSlimScreen ${mobileAppClass}`}>
            <div className="full-width">
                <div className="LoadingSlimScreenScoreboard">
                    <div className="loadinganimation_scoreboard">
                        <div className="LoadingScreen__pulsingBg" />
                        <div className="loadingIcon_cont">
                            <div className="loadingIcon_splash">
                                <LoadingIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrapper">
                <div className="left-col slim">
                    <div className="fake-game-content">
                        <div className="fake-left" />
                        <div className="fake-right" />
                    </div>
                    <div className="fake-body" />
                    <div className="fake-body2" />
                </div>
                <div className="right-col">
                    <div className="fake-ad" />
                </div>
            </div>
        </div>
    )
}

export default SlimLoadingScreen
